var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeibo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sina_Weibo 1",
    clipPath: "url(#clip0_5801_34849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.57422 19.2541C2.57422 23.2794 7.88193 26.5415 14.426 26.5415C20.9701 26.5415 26.2778 23.2794 26.2778 19.2541C26.2778 15.2289 20.9701 11.9668 14.426 11.9668C7.88193 11.9668 2.57422 15.2289 2.57422 19.2541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7061 25.9502C8.91058 26.5177 3.90713 23.928 3.53043 20.1747C3.15372 16.4165 7.54864 12.9159 13.3393 12.3484C19.1348 11.7809 24.1383 14.3706 24.5101 18.1239C24.8917 21.8821 20.4968 25.3874 14.7061 25.9502ZM26.2923 13.4787C25.7996 13.3309 25.4616 13.2355 25.7175 12.5964C26.2778 11.2086 26.3357 10.0115 25.7272 9.15305C24.5922 7.55059 21.482 7.63644 17.9178 9.11012C17.9178 9.11012 16.7973 9.59181 17.0871 8.71905C17.6328 6.97829 17.5507 5.52368 16.7007 4.67953C14.7689 2.76708 9.62536 4.75107 5.21595 9.10535C1.91734 12.3627 0 15.8204 0 18.8107C0 24.5242 7.42307 28.0009 14.6819 28.0009C24.201 28.0009 30.5326 22.5402 30.5326 18.205C30.5375 15.5819 28.3014 14.0939 26.2923 13.4787Z",
    fill: "#E6162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.6138 3.01807C30.3149 0.499932 26.9245 -0.458678 23.795 0.199472C23.0705 0.352086 22.6117 1.05793 22.7663 1.76854C22.9208 2.48392 23.6308 2.937 24.3552 2.78438C26.5816 2.317 28.9916 2.99899 30.624 4.78745C32.2564 6.5759 32.7007 9.01296 32.0004 11.1496C31.7734 11.8459 32.1598 12.5899 32.8649 12.814C33.5701 13.0382 34.3235 12.6566 34.5505 11.9651V11.9603C35.5357 8.9605 34.9127 5.53144 32.6138 3.01807Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.0839 6.16595C27.9635 4.94027 26.3117 4.47288 24.7904 4.79719C24.1674 4.92596 23.7714 5.53642 23.9018 6.15164C24.037 6.76687 24.6504 7.15795 25.2686 7.02441C26.0123 6.86703 26.8237 7.09595 27.3694 7.6921C27.9152 8.29302 28.0649 9.10855 27.8282 9.82393C27.635 10.4201 27.9635 11.0639 28.572 11.2595C29.1805 11.4502 29.8277 11.1259 30.0257 10.525C30.5038 9.06086 30.2044 7.39164 29.0839 6.16595Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.0247 19.1481C14.8219 19.4915 14.3727 19.6537 14.025 19.5106C13.6773 19.3723 13.571 18.986 13.769 18.6521C13.9719 18.3183 14.4017 18.1561 14.7446 18.2897C15.0923 18.4137 15.2179 18.8 15.0247 19.1481ZM13.175 21.485C12.6148 22.3673 11.4122 22.7536 10.5091 22.3483C9.62042 21.9476 9.35479 20.9223 9.91502 20.059C10.4704 19.2006 11.6295 18.8191 12.5278 19.191C13.4358 19.5774 13.7256 20.5932 13.175 21.485ZM15.2807 15.2374C12.523 14.5268 9.40792 15.886 8.21018 18.2849C6.9883 20.7315 8.17154 23.4499 10.9534 24.337C13.8415 25.2575 17.2415 23.8458 18.4248 21.2084C19.5935 18.6235 18.135 15.9671 15.2807 15.2374Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5801_34849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeibo);
export default __webpack_public_path__ + "static/media/weibo.f3a5e2e4d8c4c43f6848af387481f75a.svg";
export { ForwardRef as ReactComponent };